import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { FaCommentDots } from 'react-icons/fa';
import FeedbackModal from './FeedbackModal';

// Global "give feedback" entry point that lives in the navbar. The subtle pulse
// draws the eye without being noisy, and the current route is captured at open
// time so support knows what screen the feedback is about.
const FeedbackButton = () => {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  return (
    <>
      <style>{`
        @keyframes feedback-pulse {
          0% { box-shadow: 0 0 0 0 rgba(var(--bs-primary-rgb), 0.45); }
          70% { box-shadow: 0 0 0 9px rgba(var(--bs-primary-rgb), 0); }
          100% { box-shadow: 0 0 0 0 rgba(var(--bs-primary-rgb), 0); }
        }
        .feedback-pill { animation: feedback-pulse 2.5s ease-out infinite; }
        .feedback-pill:hover { animation-play-state: paused; }
      `}</style>

      <button
        className="feedback-pill btn btn-sm btn-light-primary d-flex align-items-center gap-2 rounded-pill fw-semibold"
        title="Enviar feedback"
        type="button"
        onClick={() => setShow(true)}
      >
        <FaCommentDots className="fs-5" />
        <span className="d-none d-md-inline">Feedback</span>
      </button>

      <FeedbackModal page={pathname} show={show} onClose={() => setShow(false)} />
    </>
  );
};

export default FeedbackButton;
